var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHouse = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.4891C2.5 10.3348 2.57124 10.1891 2.69303 10.0944L10.693 3.87218C10.8736 3.73175 11.1264 3.73175 11.307 3.87219L19.307 10.0944C19.4288 10.1891 19.5 10.3348 19.5 10.4891V17C19.5 17.2761 19.2761 17.5 19 17.5H3C2.72386 17.5 2.5 17.2761 2.5 17V10.4891Z",
    fill: "#5466F2",
    stroke: "#374BE3",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13C5.5 11.6193 6.61929 10.5 8 10.5C9.38071 10.5 10.5 11.6193 10.5 13V17C10.5 17.2761 10.2761 17.5 10 17.5H6C5.72386 17.5 5.5 17.2761 5.5 17V13Z",
    fill: "#2438D0",
    stroke: "#374BE3",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13C12.5 11.6193 13.6193 10.5 15 10.5C16.3807 10.5 17.5 11.6193 17.5 13C17.5 14.3807 16.3807 15.5 15 15.5C13.6193 15.5 12.5 14.3807 12.5 13Z",
    fill: "#94A0FF",
    stroke: "#374BE3",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10V15.9143",
    stroke: "#374BE3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.957 12.957L12.0427 12.957",
    stroke: "#374BE3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_940_552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4803 8.92524L11.0056 0.520508L0.520508 8.92524V11.3697L11.0056 2.97535L21.4803 11.3697V8.92524Z",
    fill: "#EC8079",
    stroke: "#D2706A",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_940_552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 11.8894,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHouse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/house.27e65cc9b68e1dbdd99b99250c50571f.svg";